export const heroOne = {
	reverse: true,
	inverse: true,
	topLine: {
		text: 'Gleich und gleich gesellt sich gern – aber Gegensätze ziehen sich an!',
	},
	headline: "Symbolik unseres Orchesters",
	description: 'Feuer und Wasser, heiß und kalt, hell und dunkel – kurz: der Inbegriff der Gegensätzlichkeit. Zwei Elemente, die seit Anbeginn der Zeit als unvereinbar gelten. Diese beiden haben ein Pendant in der Musik: Rock und Klassik. Hart und weich, laut und lieblich, aggressiv und verspielt. Doch es gibt ein paar Eingeweihte, die in der Lage sind beides zu vereinen und für die dieses\n' +
		'ungeschriebene Gesetz bei der unterhaltenden Klangproduktion nicht zu gelten scheint. Ein Experimentator und seine Helfer… und zusammen sind sie „Strings and more“',
	buttonLabel: 'Zu unserer Geschichte',

	linkTo: "/chronik",
	imgStart: 'start',
	img: './assets/HeroBilder/GuitarAndViolin.JPG',
	start: 'true',
};

export const heroTwo = {
	reverse: false,
	inverse: false,
	topLine: {
		text: 'Was Sie über uns wissen sollten!',
	},
	headline: 'Über uns',
	description: 'Wir sind zwischen 20 und 25 Jungs und Mädels unter der Leitung unseres Dirigenten Andreas Reiss, deren Leidenschaft das gemeinsame Musizieren und die moderne Musik ist. Natürlich können wir auch klassisch… aber wir waren schon immer etwas anders. Neben Violinen und Celli sind auch Querflöten, Klavier, Schlagzeug, E-Gitarre / E-Bass Teil unseres Orchesters und auch der Gesang darf bei uns nicht fehlen. Wir sind kein klassisches Streichorchester, sondern ein Rockstreichorchester… und auch ein bisschen „more“.',
	buttonLabel: 'Zu den Bildern',
	linkTo: "/galerie",

	imgStart: 'start',
	img: './assets/HeroBilder/Gruppenbild.JPG',
	start: 'true',
};

export const heroThree = {
	reverse: true,
	inverse: true,
	topLine: {
		text: 'Sie möchten uns Buchen?',
	},
	headline: 'Wir sind käuflich!',
	description:
		'Sie sind auf der Suche nach einer musikalischen Umrahmung für Ihre Veranstaltung? Dann sind sie bei uns richtig! Neben unseren eigenen Konzerten spielen wir auch auf Hochzeiten, Taufen, Firmenfeiern, Jubiläen, in der Kirche und sonstigen Veranstaltung aller Art. Unser Repertoire ist vielfältig und wird auf den jeweiligen Rahmen abgestimmt. Werfen Sie einen Blick in unsere Hörproben / Videos und kontaktieren Sie uns!',
	buttonLabel: 'Zum Kontaktformular',

	linkTo: "/kontakt",
	imgStart: '',
	img: './assets/HeroBilder/GeigeFlöteNoten.JPG',
	start: 'true',
};